import { LogOut, ShieldCheck } from 'lucide-react';
import { useAuth } from '@/components/AuthProvider';
import { useFeedback } from '@/components/Feedback';
import { HeroHeader } from '@/components/ui';
import styles from './Settings.module.css';

export default function AdminSettings() {
  const { session, signOut } = useAuth();
  const { confirm } = useFeedback();

  const handleSignOut = async () => {
    const ok = await confirm({
      title: 'Voulez-vous vous déconnecter ?',
      confirmLabel: 'Déconnexion',
      destructive: true,
    });
    if (ok) await signOut();
  };

  return (
    <div className={styles.page}>
      <HeroHeader title="Administration" />

      <div className={styles.body}>
        <div className={styles.card}>
          <span className={styles.icon}>
            <ShieldCheck size={46} />
          </span>
          <p className={styles.label}>Compte administrateur</p>
          <p className={styles.email}>{session?.user.email}</p>
        </div>

        <button
          type="button"
          className="btn btn--danger btn--block"
          onClick={() => void handleSignOut()}
        >
          <LogOut size={18} /> Se déconnecter
        </button>
      </div>
    </div>
  );
}
